export const cleanToken = (token) => {
  if (typeof token === "string") {
    return token?.replace("Bearer ", "").trim();
  }
};
